export default "__VITE_ASSET__XRop_A2A__"